// ----------------------------------------------------------------------
// <copyright file="Izenda.GaugeValueMetricItem.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * GaugeValue component
 */

import { ContainerName, MaximumField } from 'logic/data/Izenda.ReportPartGaugeConstants';

import React, { Component, PropTypes } from 'react';
import connect from 'share/enhancers/Izenda.Connect';

import GaugeValueDetailsModel from 'logic/models/Izenda.ReportPartGaugeValueDetails';
import FieldContainer from './Izenda.FieldContainer';
import InputByDataType from 'share/components/controls/Izenda.InputByDataType';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import GaugeValueSettings from './Izenda.GaugeValueSettings';
import EventsUtils from 'EventUtils';
import classnames from 'classnames';
import { CHART_TYPE } from 'logic/data/Izenda.ChartDefaultConfig';
import { get, getOr, concat } from 'lodash/fp';

const GRID_SIZE_LABEL = 3;
const GRID_SIZE_CTRL = 9;
const GRID_LABEL = 'gauge-label control-label';
const GRID_CTRL = 'gauge-control';

@connect()
export default class GaugeValueMetricItem extends Component {
  componentWillMount() {
    this.initMetricData(this.props.value);
  }

  componentWillReceiveProps(nextProps) {
    this.initMetricData(nextProps.value);
  }

  render() {
    const props = this.props;
    const localization = props.localization;

    const field = (this.field = props.value);
    const metricModel = this.metricModel;
    const hasPrimaryField = !!field;

    const reportPart = props.reportPart;
    const commonProps = {
      store: props.store,
      reportPart
    };

    return (
      <GridLayout className="gauge-item-value form-horizontal">
        {isSimpleGauge() && renderPrimaryKPI()}

        {renderValue.call(this)}
        {!isSimpleGauge() && renderScaleRange.call(this)}
        {renderUnitLabel.call(this)}
        {renderThreshold.call(this)}
        {isSimpleGauge() && renderSupplementary.call(this)}
      </GridLayout>
    );

    function isSimpleGauge() {
      return reportPart.reportPartContent.chartType === CHART_TYPE.SimpleGauge;
    }

    function renderPrimaryKPI() {
      return (
        <GridLayout.Row className="form-group">
          <GridLayout.Col cols={12}>
            <label className="control-label">{localization.getText('REPORTDESIGNER_LABEL_PRIMARY_KPI')}</label>
          </GridLayout.Col>
        </GridLayout.Row>
      );
    }

    function renderValue() {
      return (
        <GridLayout.Row className="form-group">
          <GridLayout.Col cols={GRID_SIZE_LABEL} className={GRID_LABEL}>
            {localization.getText('COMMON_LABEL_VALUE')}
          </GridLayout.Col>
          <GridLayout.Col cols={GRID_SIZE_CTRL} className={GRID_CTRL}>
            <GaugeValueSettings.FieldContainer
              {...commonProps}
              value={field}
              containerName={ContainerName.VALUES}
              onDelete={onDeleteField}
              onAdd={onAddField(props.index)}
            />
          </GridLayout.Col>
        </GridLayout.Row>
      );

      function onAddField(index) {
        return function() {
          props.onAddElement && props.onAddElement.apply(this, concat([index], arguments));
        };
      }

      function onDeleteField() {
        props.onDeleteElement && props.onDeleteElement(props.index);
      }

      function updatePreviewData() {
        return props.store.needUpdatePreview();
      }
    }

    function renderScaleRange() {
      const validation = props.validations;

      const onBlur = () => {
        props.validation.validate();
      };

      const buildValidationContran = value => ({
        action() {
          return metricModel.validateThreshold.bind(metricModel, value);
        }
      });

      const valsFrom = buildValidationContran('from');
      const valsTo = buildValidationContran('to');

      return (
        <GridLayout.Row className="form-group">
          <GridLayout.Col cols={GRID_SIZE_LABEL} className={GRID_LABEL}>
            Scale
          </GridLayout.Col>
          <GridLayout.Col cols={GRID_SIZE_CTRL} className={classnames(GRID_CTRL, 'scale-range')}>
            <span className="scale-from control-label ">{localization.getText('COMMON_LABEL_FROM')}</span>
            <InputByDataType
              type="number"
              disabled={!hasPrimaryField}
              value={get('scale.from', metricModel)}
              isDecimal
              onChange={EventsUtils.notifyChange(this.changeMetricValue('scale.from'), EventsUtils.INPUT_BY_TYPE)}
              onBlur={onBlur}
              validations={valsFrom}
              field="from"
            />
            <span className="scale-to control-label ">{localization.getText('COMMON_LABEL_TO')}</span>
            <InputByDataType
              type="number"
              disabled={!hasPrimaryField}
              value={get('scale.to', metricModel)}
              isDecimal
              onChange={EventsUtils.notifyChange(this.changeMetricValue('scale.to'), EventsUtils.INPUT_BY_TYPE)}
              onBlur={onBlur}
              validations={valsTo}
              field="to"
            />
          </GridLayout.Col>
        </GridLayout.Row>
      );
    }

    function renderUnitLabel() {
      return (
        <GridLayout.Row className="form-group">
          <GridLayout.Col cols={GRID_SIZE_LABEL} className={classnames(GRID_LABEL, 'control-label')}>
            {localization.getText('REPORTDESIGNER_LABEL_UNIT_LABEL')}
          </GridLayout.Col>
          <GridLayout.Col cols={GRID_SIZE_CTRL} className={GRID_CTRL}>
            <InputByDataType
              type="text"
              disabled={!hasPrimaryField}
              value={metricModel.unitLabel}
              onChange={EventsUtils.notifyChange(this.changeMetricValue('unitLabel'), EventsUtils.INPUT_BY_TYPE)}
            />
          </GridLayout.Col>
        </GridLayout.Row>
      );
    }

    function renderThreshold() {
      return (
        <GaugeValueSettings.ThresholdSetting
          {...commonProps}
          disabled={!hasPrimaryField}
          thresholdSetting={metricModel.thresholds}
          metricModel={metricModel}
        />
      );
    }

    function renderSupplementary() {
      return (
        <GaugeValueSettings.SupplementarySetting
          {...commonProps}
          disabled={!hasPrimaryField}
          supplementaryKPI={metricModel.supplementaryKPI}
          metricModel={metricModel}
        />
      );
    }
  }

  changeMetricValue = changedKeyPath => {
    return newVal => {
      const metricModel = this.metricModel;
      metricModel.setDataByKey && metricModel.setDataByKey(changedKeyPath, newVal);
    };
  };

  initMetricData(field) {
    this.metricModel = this.getMetricData(field);
  }

  getMetricData(field, defaultVal) {
    return getOr(defaultVal || new GaugeValueDetailsModel(), 'properties.metric', field || {});
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/FieldContainers/Izenda.GaugeValueMetricItem.js